import { render, staticRenderFns } from "./ConfigFormacaoCargaView.vue?vue&type=template&id=bc29f2ec&"
import script from "./ConfigFormacaoCargaView.vue?vue&type=script&lang=js&"
export * from "./ConfigFormacaoCargaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports